export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13320.dd7d70c6.jpg";